<template>
  <div class="container page funds-page">
    <van-nav-bar :title="$t('frontend.funds.usdt_title')" class="nav-bar">
      <template #left><button type="button" class="funds-back" :aria-label="$t('frontend.funds.back_funds')" @click="$router.push('/Setbank')"><van-icon name="arrow-left" color="#fff" /></button></template>
    </van-nav-bar>
    <main class="funds-form">
      <div v-if="loading" class="funds-status" role="status">{{ $t('common.loading') }}</div>
      <div v-else-if="loadError" class="funds-status" role="alert">{{ loadError }}<van-button size="small" @click="load">{{ $t('common.retry') }}</van-button></div>
      <form v-else @submit.prevent="save">
        <div v-for="network in networks" :key="network" class="funds-field">
          <label :for="'usdt-' + network">{{ network }}<span v-if="saved[network]" class="funds-field__status">{{ $t('setting.bindinged') }}</span></label>
          <input :id="'usdt-' + network" v-model.trim="form[network]" :placeholder="$t('frontend.funds.address_placeholder', { network: network.toUpperCase() })" :maxlength="network === 'erc20' ? 42 : 90" :readonly="Boolean(saved[network])" :disabled="submitting" autocomplete="off" autocapitalize="off" spellcheck="false" />
        </div>
        <van-button class="funds-submit" block native-type="submit" :loading="submitting" :disabled="fullyBound" :loading-text="$t('frontend.funds.saving')">{{ fullyBound ? $t('setting.bindinged') : $t('frontend.funds.add') }}</van-button>
        <p v-if="saved.trc20 || saved.erc20 || saved.btc" class="funds-note binding-note">{{ $t('frontend.funds.address_bound_note') }}</p>
      </form>
    </main>
  </div>
</template>

<script>
import { bindingData, bindingError } from '../../common/binding';

export default {
  data: () => ({
    loading: true, loadError: '', submitting: false,
    networks: ['trc20', 'erc20', 'btc'],
    form: { trc20: '', erc20: '', btc: '' }, saved: { trc20: '', erc20: '', btc: '' }
  }),
  computed: { fullyBound() { return Boolean(this.saved.trc20 && this.saved.erc20 && this.saved.btc); } },
  methods: {
    applyBinding(data) {
      this.saved = { trc20: data.trc20 || '', erc20: data.erc20 || '', btc: data.btc || '' };
      this.form = { ...this.saved };
    },
    async load() {
      this.loading = true;
      this.loadError = '';
      try { this.applyBinding(bindingData(await this.$http({ method: 'get', url: 'user_get_usdt' }))); }
      catch (error) {
        this.loadError = error.message || this.$t('frontend.funds.usdt_load_failed');
        bindingError(this, error, this.loadError);
      } finally { this.loading = false; }
    },
    async save() {
      if (this.loading || this.loadError || this.submitting || this.fullyBound) return;
      const data = {};
      for (const network of this.networks) {
        const address = this.form[network].trim();
        if (this.saved[network] || !address) continue;
        data[network] = address;
      }
      if (!Object.keys(data).length) { this.$toast(this.$t('frontend.funds.address_required')); return; }
      this.submitting = true;
      try {
        this.applyBinding(bindingData(await this.$http({ method: 'post', url: 'user_set_usdt', data })));
        this.$toast(this.$t('frontend.funds.usdt_success'));
      } catch (error) { bindingError(this, error, this.$t('frontend.funds.usdt_failed')); }
      finally { this.submitting = false; }
    }
  },
  created() {
    if (!localStorage.getItem('token')) this.$router.replace('/Login');
    else this.load();
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";
@import "../../assets/css/funds.less";
.binding-note { margin-top: 28px; }
</style>
